import * as stylex from "@stylexjs/stylex";
import { OnePagerHeaderLoading } from "./one-pager-header-loading";
import { onePagerLayout } from "./one-pager-layout.styles";
import { pageStyles } from "./one-pager-page.styles";

export function PlayOnePagerLoading({ accent }: { readonly accent: string }) {
  return (
    <div
      {...stylex.props(pageStyles.page, pageStyles.accent(accent))}
      aria-busy="true"
    >
      <output {...stylex.props(styles.srOnly)}>Loading Play</output>
      <OnePagerHeaderLoading accent={accent} />
      <div {...stylex.props(onePagerLayout.grid)}>
        <section {...stylex.props(onePagerLayout.card)} />
        <section {...stylex.props(onePagerLayout.card)} />
      </div>
    </div>
  );
}

const styles = stylex.create({
  srOnly: {
    position: "absolute",
    width: 1,
    height: 1,
    overflow: "hidden",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap",
  },
});
